module.exports = __webpack_public_path__ + "42a27983.svg";